import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import {
  normalizeWhatsAppTemplate,
  normalizeWhatsAppTemplates,
} from '@/lib/whatsapp-templates/normalize-template';
import type { PaginatedRequestResponse, RequestResponse } from '@/types';
import type {
  WhatsAppTemplate,
  WhatsAppTemplateListParams,
  WhatsAppTemplateListResult,
} from '@/types/whatsapp-template';

export const fetchWhatsAppTemplates = async (
  params: WhatsAppTemplateListParams = {}
): Promise<WhatsAppTemplateListResult> => {
  const query: Record<string, string | number | boolean> = {
    page: params.page ?? 1,
    limit: params.limit ?? 10,
  };

  if (params.search?.trim()) query.search = params.search.trim();
  if (params.category?.trim()) query.category = params.category.trim();
  if (params.status?.trim()) query.status = params.status.trim().toUpperCase();

  const response = await axiosInstance.get<PaginatedRequestResponse<unknown[]>>(
    endpoints.whatsappTemplates,
    { params: query }
  );

  const paginated = response.data.data;

  return {
    templates: normalizeWhatsAppTemplates(paginated?.data ?? []),
    currentPage: paginated?.currentPage ?? 1,
    lastPage: paginated?.lastPage ?? 1,
    total: paginated?.total ?? 0,
  };
};

export const fetchWhatsAppTemplate = async (
  id: number
): Promise<WhatsAppTemplate | null> => {
  const response = await axiosInstance.get<RequestResponse<unknown>>(
    endpoints.whatsappTemplate(id)
  );
  return normalizeWhatsAppTemplate(response.data.data);
};
